export const formatWhen = (value, withTime = true) =>
  value
    ? new Date(value).toLocaleString("en-US", withTime
      ? { dateStyle: "medium", timeStyle: "short" }
      : { dateStyle: "medium" })
    : "—";
